export var cylinder_pos_top = 126 + 170 / 2;
export var cylinder_pos = new Array();
cylinder_pos[0] = 180 + 120;
cylinder_pos[1] = 486 + 145;
cylinder_pos[2] = 798 + 160;
//cylinder_pos[3] = 750;

// Animace jednotlivych symbolu + pozice ve sprite
export var icons = {
	"symbol_Bar": {},
	"symbol_Bell": {},
	"symbol_Dollar": {},
	"symbol_Cherry": {},
	"symbol_Joker": {},
	"symbol_Melon": {},
	"symbol_Orange": {},
	"symbol_Plum": {},
	"symbol_Star": {}
};

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;
symbols[3] = -1;

export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;

export var symbols_before_stop = 6;

export var render_move_per_sec = 18; // Symbolu za sekundu
export var render_move_per_sec_free = 18; // Symbolu za sekundu ve free spinu

function init_game(dname, config, ver)
{
	if(typeof ver == 'undefined') {
		ver = 1;
	}

	// madnes_config_load_symbols = false;

	// madnes_set_languages(['en', 'cs', 'sk']);
	// madnes_set_def_lang('en');
	//
	// madnes_coins_shift = -80;

	//madnes_show_money_anim_scale_from = 0.8;
	//madnes_show_money_anim_scale_to = 1;
	// madnes_show_money_pos_x = wi / 2 - 40;
	// madnes_show_money_pos_y = he / 2 + 40;

	// madnes_show_money_anim_callback_timeout = 40;

	// madnes_load_init("joker_27", config);
	//
	// madnes_set_page_bg(dname, imgsPath + "web/background.png");
	//
	// madnes_set_texture_version(ver);

	// madnes_set_ico_size(220, 170);
	// madnes_set_native_sceen_size(1280, 720);

	// for(var i in to_load_audio)
	// {
	// 	madnes_add_audio(i, to_load_audio[i]);
	// }
	//
	// add_wintables_to_load();
	//
	// for(var i in to_load)
	// {
	// 	madnes_add_to_load(i, to_load[i]);
	// }
	//
	// for(var i in to_load_json_atlas) {
	// 	madnes_add_json_atlas_to_load(i, to_load_json_atlas[i][0], to_load_json_atlas[i][1]);
	// }
	//
    // for(var i in to_load_json)
    // {
    //     if(infotexts_languages.indexOf(lang) === -1)
    //     {
    //         to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    //     }
	//
    //     madnes_add_json(i, to_load_json[i]);
    // }
	//
	// for(var i in to_load_fonts)
	// {
	// 	madnes_add_font_to_load(i, to_load_fonts[i]);
	// }

	// madnes_set_sprite('_sprite', 220, 170);
	// madnes_set_sprite('_blur', 220, 170);

	// madnes_set_printdesk_function(print_desk);
	// madnes_set_updatedesk_function(print_reels);
	// madnes_set_rotate_function(rotate_run);
	// //madnes_set_on_rotate_click(rotate_onclick);
	//
	// madnes_set_infomenu_init_function(infomenu_init);
	// madnes_set_infomenu_open_function(infomenu_open);
	// madnes_set_infomenu_close_function(infomenu_close);
	// madnes_set_infomenu_update_function(infomenu_click);
	// madnes_set_infomenu_left_function(infomenu_left);
	// madnes_set_infomenu_right_function(infomenu_right);
	// madnes_set_betmenu_open_function(betmenu_open);
	//
	// madnes_set_coin_values_init(function(currency)
	// {
	// 	if(currency === "PLN")
	// 	{
	// 		coin_values = [0.1, 1];
	// 	}
	// 	else
	// 	{
	// 		madnes_coin_values_init(currency);
	// 	}
	// });
	//
	// madnes_init(dname);
}